import { SET_ACCOUNT_TRADE_HISTORY, SET_TRADE_HISTORY, SET_FETCH_TRADE_HISTORY } from './action'

const initialState = {
  tradeHistory: { trade: [] },
  accountTradeHistory: { trade: [] },
  isFetchTradeHistory: false,
}

const castWSTT = tt => {
  switch (tt) {
    case 0:
      return 'Unknown'
    case 1:
      return 'SellTaker'
    case 2:
      return 'BuyTaker'
    case 3:
      return 'BuySurplus'
    case 4:
      return 'SellSurplus'
    case 5:
      return 'Neutral'
    default:
      return 'Unknown'
  }
}

const handleTradeHistory = data => {
  data.trade = data.trade.map(item => ({
    tickType: item.tickType || castWSTT(item.tt),
    ...item,
  }))
  return data
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TRADE_HISTORY:
      return {
        ...state,
        tradeHistory: handleTradeHistory(action.data || []),
      }
    case SET_ACCOUNT_TRADE_HISTORY:
      return {
        ...state,
        accountTradeHistory: action.data,
      }

    case SET_FETCH_TRADE_HISTORY:
      return {
        ...state,
        isFetchTradeHistory: action.data,
      }

    default:
      return state
  }
}
